import { Outlet } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import { BootSplash } from '@/components/BootSplash';
import { CrossHostNavigate } from '@/components/CrossHostNavigate';

export function GuestGuard() {
  const { isAuthenticated, isAdmin, isLoading, user } = useAuth();

  if (isLoading) {
    return <BootSplash />;
  }

  if (isAuthenticated) {
    if (isAdmin) {
      return <CrossHostNavigate to="/admin" />;
    }
    if (user && (user.shops?.length ?? 0) === 0) {
      return <CrossHostNavigate to="/owner/onboarding" />;
    }
    return <CrossHostNavigate to="/owner/dashboard" />;
  }

  return <Outlet />;
}
